import React, { Fragment } from 'react';
import {
  Container,
  Button,
  Card,
  Form,
  Row,
  Col,
  Tooltip,
  OverlayTrigger,
  Alert as BAlert
} from 'react-bootstrap';
import MasterPage from 'components/MasterPage';
import { useEffect } from 'react';
import { useState } from 'react';
import ActionRequestService from '../../../services/action-request';
import ResalesRequestService from '../../../services/resales-request';
import {
  FlowType,
  FundType,
  ActionType,
  ActionStatus,
} from '../../../helpers/Enum/index';
import Params from '../../../helpers/Params';
import DatePicker from 'react-datepicker';
import Currency, { currencyReverse } from 'helpers/Currency';
import 'react-datepicker/dist/react-datepicker.css';
import Historic from '../../../components/Historic';
import FileUploadMultiple from 'components/FileUploadMultiple';
import {
  WidgetsOutlined,
  ArrowBackIos,
  ErrorOutlineOutlined,
  HelpOutline,
} from '@material-ui/icons';
import { Link } from 'react-router-dom';
import Unauthorized from 'components/Unauthorized';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import Swal from 'sweetalert2'
import Alert from '../../../helpers/alert';

import '../style.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronUp, faChevronDown } from '@fortawesome/free-solid-svg-icons';

import FormatDate from 'helpers/FormatDate';
import SelectFiscalYears from 'components/SelectFiscalYears';
import { useProfile, useUser, useCompany } from 'models';

const ShowV1 = ({
  action_aux,
  bus_aux,
  flow_aux,
  categories_aux,
}) => {
  const user = useUser()
  const currentCompany = useCompany()

  const profile = useProfile()
  const [actionId, setActionId] = useState(Params.get('id'));
  const [action, setAction] = useState({bu:3});
  const [actionAux, setActionAux] = useState(null);
  const [actionValue, setActionValue] = useState({});
  const [listFiscalYear, setListFiscalYear] = useState([{ id: 10, fiscal_year: "2022" }]);
  const [fiscalYear, setFiscalYear] = useState(5);
  const [companyId, setCompanyId] = useState(
    currentCompany
      ? currentCompany.id
      :  user.currentCompany ? user.currentCompany.id : '');

  const [file, setFile] = useState([]);
  const [filecomments, setFilecomments] = useState([]);

  const [bus, setBus] = useState([]);
  const [flow, setFlow] = useState(null);
  const [categories, setCategories] = useState([]);

  const [rodando, setRodando] = useState(true);

  const [demonstrative, setDemonstrative] = useState(null);
  const [status, setStatus] = useState(null);
  const [steps, setSteps] = useState([]);
  const [statusId, setStatusId] = useState(null);
  const [startDate, setStartDate] = useState(null);

  const [fundsMobileCollapsed, setFundsMobileCollapsed] = useState(true);

  const { t } = useTranslation();

  const [editable, setEditable] = useState(true);

  const [actionToShow, setActionToShow] = useState(); // Ação executada [rejeitada, cancelada, autorizada,...]

  const history = useHistory();

  const [bu_enabled, setBuEnabled] = useState([]);
  const [fund_enabled, setFundEnabled] = useState([]);
  const [totalFunds, setTotalFunds] = useState(0);

  useEffect(()=>{
    let aux_action = action_aux;
    setStatusId(aux_action.action_status_id);
    setFiscalYear(aux_action.fiscal_year_id);
    aux_action.company.fiscal_years_elite.length > aux_action.company.group_years ? 
    setListFiscalYear(aux_action.company.fiscal_years_elite) : 
    setListFiscalYear(aux_action.company.group_years);
    setStartDate(aux_action.start_at);
    setCompanyId(aux_action.company_id);
    changeFiscalYear(aux_action.fiscal_year_id);
    setAction(action_aux)
    setActionAux(action_aux)
    loadDemonstrative(action_aux)
  },[action_aux]);

  useEffect(()=>{
    setBus(bus_aux)
  },[bus_aux]);

  useEffect(()=>{
    setFlow(flow_aux)
  },[flow_aux]);

  useEffect(()=>{
    setCategories(categories_aux)
  },[categories_aux]);

  useEffect(() => {
    // getBus();
    // getFlow();
    // getCategories();
    // if (actionId) getAction();
    // else {
    //   setValue(
    //     'fiscal_year_id',
    //     currentCompany ?
    //       currentCompany.fiscal_years_elite.length > 1 ? currentCompany.fiscal_years_elite[1].id : currentCompany.fiscal_years_elite[0].id
    //       : 5
    //   );
    //   loadDemonstrative(null);
    // }
  }, []);

  useEffect(() => {
    if (action.id && flow && rodando) {
      let aux_status = Object.values(flow.action_status).filter(
        (status) => status.id === statusId
      )[0];
      setStatus(aux_status);
      let aux_steps = user.profile.routes.filter((r) => r.alias === 'marketing.edit')[0]
        .flow.user_steps;
      setSteps(
        Object.values(aux_steps).filter(
          (a) => a.action_status_id === aux_status.id
        )[0]
          ? aux_status.next_steps
          : null
      );
      if (
        (aux_steps && aux_status.id != ActionStatus().AcaoRejeitada) ||
        !Object.values(aux_steps).filter(
          (a) => a.action_status_id === aux_status.id
        )[0]
      ) {
        setEditable(false);
        setRodando(false);
      }
    } else if (flow && rodando) {
      setSteps(
        Object.values(flow.action_status).filter(
          (f) => f.id === flow.action_status_id
        )
      );
    }
  }, [action, flow]);

  useEffect(() => {
    if (action.id) {
      //setValue('fiscal_year_id', currentCompany.fiscal_years_elite[0]?currentCompany.fiscal_years_elite[0]:user.area.fiscal_year.id);
      loadDemonstrative(action);
    } else {
      loadDemonstrative(null);
    }
  }, [fiscalYear]);

  useEffect(() => {
      let total = 0
      Object.values(actionValue).forEach(v => {
        if (v) {
          total += v.pivot.value
        }
      })
      setTotalFunds(total)
  }, [actionValue]) 

  const getAction = () => {
    let request = ActionRequestService.get(actionId, {
      params: {
        embed:
          'action_histories.user,action_histories.action_status,files,funds,company',
      },
    });
    request.then((data) => {
      let aux_action = data.data.data;
      setStatusId(aux_action.action_status_id);
      setFiscalYear(aux_action.fiscal_year_id);
      aux_action.company.fiscal_years_elite.length > aux_action.company.group_years ? 
        setListFiscalYear(aux_action.company.fiscal_years_elite) : 
        setListFiscalYear(aux_action.company.group_years);
      aux_action.start_at = new Date(FormatDate.parseDate(aux_action.start_at));
      aux_action.end_at = new Date(FormatDate.parseDate(aux_action.end_at));
      setStartDate(aux_action.start_at);
      aux_action.pay_date = aux_action.pay_date
        ? new Date(FormatDate.parseDate(aux_action.pay_date))
        : '';
      aux_action.estimated_pay_date = aux_action.estimated_pay_date
        ? new Date(FormatDate.parseDate(aux_action.estimated_pay_date))
        : '';
      // loadDemonstrative(aux_action);
      setCompanyId(aux_action.company_id);
      changeFiscalYear(aux_action.fiscal_year_id);
      setAction(aux_action);
      setActionAux(aux_action);
    });
  };

  const getBus = () => {
    let request = ActionRequestService.getBusinessUnities({
      params: {
        embed: 'funds|type_id=' + FundType().Marketing,
      },
    });
    request.then((data) => {
      setBus(data.data.data);
    });
  };

  const getFlow = () => {
    let request = ActionRequestService.getFlow(FlowType.Marketing);
    request.then((data) => {
      setFlow(data.data.data);
    });
  };

  const getCategories = () => {
    let request = ActionRequestService.getCategories({
      params: {
        embed: 'subcategories',
      },
    });
    request.then((data) => {
      setCategories(data.data.data);
    });
  };

  const loadDemonstrative = (action, fiscal_year_id = null, company_id = null) => {
    const buildDemonstrative = (fund) => {
      let actions = fund.actions;
      let actionsPaid = actions.filter((a) => {
        return (
          a.action_status_id === ActionStatus().Finalizada &&
          a.action_status_id !== ActionStatus().Cancelada
        );
      });
      let runningActions = actions.filter((a) => {
        return (
          a.action_status_id !== ActionStatus().Finalizada &&
          a.action_status_id !== ActionStatus().Cancelada
          && !(a.action_status_id == ActionStatus().AcaoRejeitada && Params.get('id') && a.id === parseInt(Params.get('id')))
        );
      }); 

      let spending = actionsPaid.reduce((total, value) => {
        return total + value.pivot.value;
      }, 0);
      let spendingPlanned = runningActions.reduce((total, value) => {
        return total + value.pivot.value;
      }, 0);

      let freeFund = parseFloat(fund.pivot.value) - parseFloat(spending) - parseFloat(spendingPlanned)
      return {
        id: fund.id,
        bu: fund.business_unity_id,
        name: fund.alias,
        key: fund.name,
        freeFund: (parseFloat(freeFund.toFixed(2)) <= 0 && action) || freeFund.toFixed(2)=='-0.00' ? 0.00 : parseFloat(freeFund.toFixed(2)),
      };
    };

    if (!actionId && currentCompany == null) return showMessageErro();

    if (action) {
      let request = ActionRequestService.get(actionId, {
      });
      request.then((data) => {
        let company_id = data.data.data.company_id;
        if (company_id) {
          let filters = {
            embed: 'actions',
            type_id: 1,
            fiscal_year_id: action ? action.fiscal_year_id : fiscalYear
          };
          let request = ResalesRequestService.getCompanyFunds(company_id, {
            params: { ...filters },
          });
          request.then((data) => {
            let result = data.data.data;
            let demonstrative = [];
            result.funds.forEach((fund, key) => {
              demonstrative[key] = buildDemonstrative(fund);
            });
            demonstrative = groupBy(demonstrative, 'bu');
            let bus_aux = []
            Object.values(demonstrative).forEach(a => {
              a.map(b => bus_aux.push(b.bu));
            });
            setBuEnabled(bus_aux);
            setDemonstrative(Object.values(demonstrative));
          });
        }
      });
    } else {
      if (companyId) {
        let filters = {
          embed: 'actions',
          type_id: 1,
          fiscal_year_id: action ? action.fiscal_year : fiscal_year_id ?? fiscalYear
        };
        let request = ResalesRequestService.getCompanyFunds(companyId, {
          params: { ...filters },
        });
        request.then((data) => {
          let result = data.data.data;
          let demonstrative = [];
          result.funds.forEach((fund, key) => {
            let aux_fund = buildDemonstrative(fund)
            if (fund.pivot.value > 0 || profile.havePermission('marketing.overflow-value'))
              demonstrative[key] = aux_fund;
          });
          demonstrative = groupBy(demonstrative, 'bu');

          let bus_aux = []
          Object.values(demonstrative).forEach(a => {
            a.map(b => bus_aux.push(b.bu));
          });
          setBuEnabled(bus_aux);
          setDemonstrative(Object.values(demonstrative));
        });
      }
    }
  };

  const groupBy = function (xs, key) {
    return xs.reduce(function (rv, x) {
      (rv[x[key]] = rv[x[key]] || []).push(x);
      return rv;
    }, {});
  };


  const setCheckedFund = (fundId, actionFunds, k) => {
    let aux_action_value = { ...actionValue };
    if (actionFunds.filter((af) => af.id === fundId)[0]) {
      if (!aux_action_value[k] && aux_action_value[k] !== null) {
        aux_action_value[k] = {};
        aux_action_value[k].id = actionFunds.filter((af) => af.id === fundId)[0].id;
        aux_action_value[k].pivot = actionFunds.filter((af) => af.id === fundId)[0].pivot;
        setActionValue({ ...aux_action_value });
        let total = totalFunds;
        setTotalFunds(total += aux_action_value[k].pivot.value)
      }
    }
    return aux_action_value[k];
  }

  const changeFiscalYear = (id) => {
    const filter = {
      fiscal_year_id: id,
      company_id: companyId
    };
    let companies = ResalesRequestService.getGroupHeadquarter({
      params: { ...filter },
    });
    companies.then((data) => {
      let c = data.data.data;
      setCompanyId(data.data.data.company_id)
      setFiscalYear(id);
    });
  }

  const getFormBu = () => {
    if (action.id) {
      let actionFunds = Object.values(action.funds);
      let buKey = bus.filter(
        (b) => b.id === action.funds[0].business_unity_id
      )[0];
      let bu = bus.filter((b) => b.id === buKey.id)[0];
      if (bu)
        return (
          <Row>
            <Col sm="12">
              <Form.Group>
                <Form.Label>Selecione o Fundo</Form.Label>
                {bu.funds.map((fund, k) => {                  
                  return (
                    <Row key={k}>
                      <Col xs={6}>
                        <Form.Group>
                          <Form.Check
                            type="checkbox"
                            checked={
                              setCheckedFund(fund.id, actionFunds, k)
                              // actionFunds.filter((af) => af.id === fund.id)[0]
                            }
                            disabled={!editable}
                            label={fund.alias}
                            onChange={(e) => {
                              let isChecked = e.currentTarget.checked;
                              let aux_action_value = { ...actionValue };
                              if (isChecked) {
                                aux_action_value[k] = {};
                                aux_action_value[k].id = fund.id;
                                aux_action_value[k].pivot = {};
                                aux_action_value[k].pivot.value = '';
                              } else {
                                aux_action_value[k] = null;
                              }
                              setActionValue({ ...aux_action_value });
                            }}
                          />
                        </Form.Group>
                      </Col>
                      <Col key={k} xs={6}>
                        <Form.Group>
                          <Form.Label>Valor</Form.Label>
                          <Currency
                            value={
                              actionValue[k] ? actionValue[k].pivot.value : ''
                              // actionFunds.filter((af) => af.id === fund.id)[0]
                              //   ? actionFunds.filter(
                              //     (af) => af.id === fund.id
                              //   )[0].pivot.value
                              //   : ''
                            }
                            disabled={!actionValue[k] ? true : !editable}
                            onChange={(e) => {
                              let aux_action_value = { ...actionValue };
                              if (aux_action_value[k]) {
                                aux_action_value[
                                  k
                                ].pivot.value = currencyReverse(e.target.value);
                                setActionValue({ ...aux_action_value });
                              }
                            }}
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                  );
                })}
              </Form.Group>
            </Col>
            <Col md="6" className="offset-md-6">
              <Form.Group>
                <Form.Label>Total: {new Intl.NumberFormat('pt-br', { style: 'currency', currency: 'BRL' }).format(totalFunds)}</Form.Label>
              </Form.Group>
            </Col>
          </Row>
        );
    } else {
      let bu = bus.filter((b) => b.id == getValue('bu'))[0];
      if (bu)
        return (
          <Row>
            <Col>
              <Form.Group>
                <Form.Label>Selecione o Fundo</Form.Label>
                {bu.funds.filter((fund, k) => {
                  let fund_aux = []
                  try {
                    demonstrative.forEach(a => {
                      return a.forEach(b => {
                        if (b.bu == getValue('bu'))
                          fund_aux.push(b.key);
                      })
                    })
                    if(fund_aux.indexOf(fund.name) == -1) return false;
                  } catch (error) { }
                  return true;
                }).map((fund, k) => {
                  return (
                    <Row key={k}>
                      <Col xs={6}>
                        <Form.Group>
                          <Form.Check
                            type="checkbox"
                            checked={actionValue[k]}
                            disabled={!editable}
                            label={fund.alias}
                            onChange={(e) => {
                              let isChecked = e.currentTarget.checked;
                              let aux_action_value = { ...actionValue };
                              if (isChecked) {
                                aux_action_value[k] = {};
                                aux_action_value[k].id = fund.id;
                                aux_action_value[k].pivot = {};
                                aux_action_value[k].pivot.value = '';
                              } else {
                                aux_action_value[k] = null;
                              }
                              setActionValue({ ...aux_action_value });
                            }}
                          />
                        </Form.Group>
                      </Col>
                      <Col key={k} xs={6}>
                        <Form.Group>
                          <Form.Label>Valor</Form.Label>
                          <Currency
                            value={
                              actionValue[k] ? actionValue[k].pivot.value : ''
                            }
                            disabled={!actionValue[k] ? true : !editable}
                            onChange={(e) => {
                              if (e.target.value == "") {
                                e.target.value = 0.00
                              }

                              let aux_action_value = { ...actionValue };
                              if (aux_action_value[k]) {
                                let value_aux = currencyReverse(e.target.value);
                                demonstrative.forEach(element => {
                                  element.forEach(f=>{
                                    if(aux_action_value[k].id == f.id){
                                      if(value_aux > f.freeFund && !profile.havePermission('marketing.overflow-value')) {
                                        value_aux = f.freeFund > 0 ?f.freeFund:0;
                                      }
                                    }
                                  })
                                });
            
                                aux_action_value[k].pivot.value = value_aux;
                                setActionValue({ ...aux_action_value });
                              }
                            }}
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                  );
                })}
              </Form.Group>
            </Col>            
            <Col md="6" className="offset-md-6">
              <Form.Group>
                <Form.Label>Total: {new Intl.NumberFormat('pt-br', { style: 'currency', currency: 'BRL' }).format(totalFunds)}</Form.Label>
              </Form.Group>
            </Col>
          </Row>
        );
    }
  };

  const submit = (e) => {
    const btndisabled = (disabled) => {
      let btns = document.getElementsByClassName('btnsubmit');
      for (let index = 0; index < btns.length; index++) {
        const element = btns[index];
        element.disabled = disabled;
      }
    };

    e.preventDefault();
    btndisabled(true);
    let erro = { status: false, erros: [] };
    if (action.id && action.action_status_id === actionAux.action_status_id) {
      erro.status = true;
      erro.erros.push('status required');
    }
    const isRequired = (key) => {
      if (action.step)
        return action.step.fields.map((a) => a.model_field === key)[0];
      return false;
    };
    let required = [
      { key: 'bu', required: true, label: 'BU' },
      { key: 'title', required: true, label: 'Nome' },
      { key: 'subcategory_id', required: true, label: 'Tipo de Ação' },
      { key: 'start_at', required: true, label: 'Data Inicial' },
      { key: 'end_at', required: true, label: 'Data Final' },
      {
        key: 'estimated_pay_date',
        required: isRequired('estimated_pay_date'),
        label: 'data',
      },
      { key: 'pay_date', required: isRequired('pay_date'), label: 'data' },
      { key: 'description', required: true, label: 'Descrição' },
      { key: 'action_status_id', required: true },
      { key: 'fiscal_year_id', required: true },
      { key: 'action_history_description' },
      // {
      //   key: 'payment_require', required: (getValue('subcategory_id') == 6), label: 'Pagamento Requerido'
      // }
    ];
    const formData = new FormData();
    formData.append('user_id', user.id);
    formData.append('company_id', companyId);
    formData.append('id', action.id ? action.id : '');
    formData.append('action_type_id', ActionType().Marketing);
    formData.append('fiscal_year_id', fiscalYear);

    if (getValue('subcategory_id') == 6) {
      formData.append('payment_require', getValue('payment_require'))
      required.push({
        key: 'payment_require', required: true, label: 'Pagamento Requerido'
      })
    }    

    file.forEach((f, k) => {
      formData.append('file[' + k + ']', f);
      formData.append('filecomments[' + k + ']', filecomments[k].value);
    });

    const formatDate = (date) => {
      return (
        date.getUTCFullYear() +
        '-' +
        ('00' + (date.getUTCMonth() + 1)).slice(-2) +
        '-' +
        ('00' + date.getUTCDate()).slice(-2) +
        ' ' +
        ('00' + date.getUTCHours()).slice(-2) +
        ':' +
        ('00' + date.getUTCMinutes()).slice(-2) +
        ':' +
        ('00' + date.getUTCSeconds()).slice(-2)
      );
    };

    required.forEach((k) => {
      if (k.required) {
        if (
          action[k.key] &&
          action[k.key] !== '' &&
          action[k.key] !== null &&
          action[k.key] !== 0
        )
          if (
            k.key !== 'start_at' &&
            k.key !== 'end_at' &&
            k.key !== 'estimated_pay_date' &&
            k.key !== 'pay_date'
          )
            formData.append(k.key, action[k.key]);
          else {
            formData.append(k.key, formatDate(action[k.key]));
          }
        else {
          if (k.key === 'bu') {
            if (!action.id) {
              erro.status = true;
              erro.erros.push(k.label);
            }
          } else {
            erro.status = true;
            erro.erros.push(k.label);
          }
        }
      } else {
        if (
          k.key !== 'start_at' &&
          k.key !== 'end_at' &&
          k.key !== 'estimated_pay_date' &&
          k.key !== 'pay_date'
        )
          formData.append(k.key, action[k.key] ? action[k.key] : '');
        else {
          formData.append(
            k.key,
            action[k.key] ? formatDate(action[k.key]) : ''
          );
        }
      }
    });

    let bu = bus.filter((b) => b.id == getValue('bu'))[0];
    if (bu) {
      let erroBu = true;
      bu.funds.filter((fund, k) => {
        let fund_aux = []
        try {
          demonstrative.forEach(a => {
            return a.forEach(b => {
              if (b.bu == getValue('bu'))
                fund_aux.push(b.key)
            })
          })
          if (fund_aux.indexOf(fund.name) == -1) return false;
        } catch (error) {}
        return true;
      }).forEach((fund, k) => {

        let dem = demonstrative.filter(a => {
          return a.filter(b => b.bu == fund.business_unity_id)[0]
        })[0];
        //let dem = demonstrative[fund.business_unity_id - 1];
        if (
          actionValue[k] &&
          actionValue[k].pivot.value &&
          actionValue[k].pivot.value !== '' &&
          actionValue[k].pivot.value !== null &&
          actionValue[k].pivot.value > 0
        ) {
          if (
            dem[k].freeFund.toFixed(2) >= actionValue[k].pivot.value ||
            user.currentProfile.name === 'Administrador'
          ) {
            erroBu = false;
            formData.append(
              'action_values[' + k + '][fund_id]',
              actionValue[k].id
            );
            formData.append(
              'action_values[' + k + '][value]',
              actionValue[k].pivot.value
            );
          } else {
            erroBu = false;
            erro.status = true;
            erro.erros.push('Valor não pode ser maior do que o fundo disponível');
          }
        }
      });
      if (erroBu) {
        erro.status = true;
        erro.erros.push('Fundos');
      }
    } else {
      if (!action.id) {
        erro.status = true;
      }
    }

    if (action.id) {
      formData.append('_method', 'put');
      // let actionFunds = Object.values(action.funds);
      let buKey = bus.filter(
        (b) => b.id === action.funds[0].business_unity_id
      )[0];
      let bu = bus.filter((b) => b.id === buKey.id)[0];
      bu.funds.forEach((fund, k) => {
        //let dem = demonstrative[fund.business_unity_id - 1];
        let dem = demonstrative.filter(a => {
          return a.filter(b => b.bu == fund.business_unity_id)[0];
        })[0];
        // let action_value = action.funds.filter((f) => f.id === fund.id)[0];
        if (actionValue[k]) {
          if (
            dem[k].freeFund.toFixed(2) >= actionValue[k].pivot.value ||
            user.currentProfile.name === 'Administrador'
            || (statusId !== ActionStatus().AcaoRejeitada && dem[k].freeFund.toFixed(2) <= actionValue[k].pivot.value)
          ) {
            formData.append('action_values[' + k + '][fund_id]', actionValue[k].id);
            formData.append(
              'action_values[' + k + '][value]',
              actionValue[k].pivot.value
            );
            if (actionValue[k].pivot.id) {
              formData.append(
                'action_values[' + k + '][id]',
                actionValue[k].pivot.id
              );
            }
          } else {
            erro.status = true;
            erro.erros.push('O valor não pode ser maior do que o fundo disponível');
          }
        }
      });
    }

    // formData.forEach((v, k) =>{
    //   console.log(k, v)
    // })
    //return;
    if (!erro.status) {
      let request = actionId
        ? ActionRequestService.update(actionId, formData)
        : ActionRequestService.create(formData);      

      request.then((data) => {
        setActionToShow(actionId ? "Atualizada" : "Solicitada");

        Alert.success(`${actionToShow} com sucesso`).then((result) => {
          if (result.dismiss === Swal.DismissReason.timer) {
            history.push('/elite/actions')
          }
        });
        //window.location.href = '/elite/actions';
      }).catch(error=>{
        btndisabled(false);
      });
    } else {
      erro.erros.map((e) => {
        toast.error(e, {
          autoClose: 5000,
        });
      });
      btndisabled(false);
    }
  };

  const getValue = (name) => {
    return action[name] ? action[name] : '';
  };

  const setValue = (name, value) => {
    let action_aux = { ...action };
    action_aux[name] = value;
    setAction({ ...action_aux });
  };

  const createField = (fields, action, steps) => {
    const getTemplate = (field) => {
      let retorno = <></>;
      switch (field.component.name) {
        case 'Date':
          retorno = (
            <>
              <Col md="4">
                <Form.Group>
                  <Form.Label>{t('label:' + field.label)}</Form.Label>
                  <DatePicker
                    disabled={field.editable && steps ? false : true}
                    dateFormat="dd/MM/yyyy"
                    selected={getValue(field.name)}
                    onChange={(e) => setValue(field.name, e)}
                    className="form-control"
                  />
                </Form.Group>
              </Col>
            </>
          );
          break;
        default:
          break;
      }
      return retorno;
    };

    fields = fields.sort(function (a, b) {
      if (a.order === b.order) {
        return 0;
      }
      return a.order < b.order ? -1 : 1;
    });

    return (
      <>
        {fields.map((f, k) => {
          return <>{getTemplate(f)}</>;
        })}
      </>
    );
  };

  const getDay = () => {
    let a = new Date();
    return a.getDate();
  };

  const showMessageErro = () => {
    return <Unauthorized />;
  };

  const showMessageErro2 = () => {
    return (
      <>
        <Container>
          <Row>
            <Col className="col-12 d-flex justify-content-center my-5">
              <Card.Body className="shadow bg-white rounded text-center m-2 col-9 pt-5">
                <Row className="text-center row">
                  <Col xs="12">
                    <ErrorOutlineOutlined className="icon-title" />
                    <h5 className="title-dashboard">Atenção!</h5>
                  </Col>
                </Row>
                <Row>
                  <Col className="col-12 align-self-center p-3">
                    <h5 className="text-black px-4">
                      Período de bloqueio para solicitação de novas ações.
                    </h5>
                    <h5 className="text-black px-4">
                      A partir do dia primeiro do mês seguinte o sistema será
                      reaberto para novas solicitações.
                    </h5>
                    <h5 className="text-black mb-4 px-4">
                      Dúvidas consulte a seção de Perguntas e Respostas{' '}
                      <a href="../../faq">(FAQ)</a>.
                    </h5>
                  </Col>
                </Row>
              </Card.Body>
            </Col>
          </Row>
        </Container>
      </>
    );
  };

  const getProfile = () => {
    return localStorage.getItem('profile');
  };

  const renderTooltip = (props) => (
    <Tooltip id="help-tooltip" {...props}>
      Ao abrir uma solicitação de resgate anexar somente comprovações prévias da
      ação (opcional nesta etapa). A nota fiscal de reembolso só deve ser
      emitida e enviada após ação estar Autorizada.
    </Tooltip>
  );

  const getTamanho = (tamanho) => {
    return window.innerWidth <= tamanho;
  }

  return (
    <>
      {actionId || currentCompany ? (
        getDay() > 20 &&
          getDay() <= 31 &&
          !actionId &&
          getProfile() != 'Administrador' ? (
            showMessageErro2()
          ) : (
            <Container>
              <Row className="mt-4">
                <Link to="/elite/actions" className="link-back">
                  <ArrowBackIos className="icon-title icon-back" />
                  <h6 className="font-13 mt-3">Voltar</h6>
                </Link>
              </Row>
              <Row className="mt-2">
                <WidgetsOutlined className="icon-title col-auto p-0" />
                <h5 className="title-dashboard col-10 p-0">Marketing - Solicitar ação</h5>
              </Row>
              <Row>
                <Col md='12' lg='7' xs="12" xl="8" className="p-2">
                  <Card.Body className="card-dashboard shadow bg-white rounded text-left row w-100 h-100 m-0">
                    <Row>
                      {status ? (
                        <Col xs={12}>
                          <Form.Group>
                            <Form.Label>Status atual: </Form.Label>
                            {' ' + status.name}
                          </Form.Group>
                        </Col>
                      ) : (
                          ''
                        )}
                      <Col xs={12} className={getTamanho(358) ? 'p-0' : ''}>
                        <Form onSubmit={(e) => submit(e)}>
                          <Row>
                            <Col>
                              <Form.Group>
                                <Form.Label>Selecione a BU</Form.Label>
                                {bus.map((bu, k) => {
                                  if (bu_enabled.indexOf(bu.id) == -1) return '';
                                  return (
                                    <div key={k} className="radio radio-info ml-2">
                                      <Form.Check
                                        type={'radio'}
                                        value={bu.id}
                                        id={bu.id}
                                        label={bu.name}
                                        disabled={true}
                                        onChange={(e) =>{
                                          setValue('bu', e.target.value)
                                          setActionValue({});
                                        }}
                                        checked={
                                          action.id &&
                                            action.funds[0].business_unity_id == bu.id
                                            ? true
                                            : bu.id == getValue('bu')
                                        }
                                        required
                                      />
                                    </div>
                                  );
                                })}
                              </Form.Group>
                            </Col>
                            {/* {listFiscalYear.length > 1  ? (
                              <Col md='3' lg='3' xs="12" xl="2">
                                <Form.Group>
                                  <Form.Label>Ano Fiscal:</Form.Label>
                                  <Form.Control
                                    as="select"
                                    disabled={actionId}
                                    value={getValue('fiscal_year_id')}
                                    onChange={(e) => {
                                      setValue('fiscal_year_id', e.target.value);
                                      changeFiscalYear(e.target.value);
                                    }}
                                  >
                                    <SelectFiscalYears listFY={listFiscalYear}/>
                                  </Form.Control>
                                </Form.Group>
                              </Col>
                            ) : (
                                ''
                              )} */}
                          </Row>
                          {getFormBu()}
                          <Row>
                            <Col
                              md={12}
                              xl={12}
                              xs={12}
                            >
                              <Form.Group>
                                <Form.Label>Nome da Atividade:</Form.Label>
                                <Form.Control
                                  as="input"
                                  disabled={!editable}
                                  value={getValue('title')}
                                  onChange={(e) =>
                                    setValue('title', e.target.value)
                                  }
                                ></Form.Control>
                              </Form.Group>
                            </Col>

                            <Col xs={getTamanho(565) ? 12 : 4}>
                              <Form.Group>
                                <Form.Label>Tipo de Ação:</Form.Label>
                                <Form.Control
                                  as="select"
                                  onChange={(e) => {
                                    setValue('subcategory_id', e.target.value)
                                  }}
                                  value={getValue('subcategory_id')}
                                  disabled={!editable}
                                >
                                  <option value="">Selecione</option>
                                  {categories.map((category, k) => {
                                    return (
                                      <optgroup key={k} label={category.name}>
                                        {category.subcategories.filter((a)=>{
                                          return a.deactivate == 0 || getValue('subcategory_id') == a.id;
                                        }).map(
                                          (subcategory, k) => {
                                            return (
                                              <option
                                                key={k}
                                                value={subcategory.id}
                                              >
                                                {subcategory.name}
                                              </option>
                                            );
                                          }
                                        )}
                                      </optgroup>
                                    );
                                  })}
                                </Form.Control>
                              </Form.Group>
                            </Col>
                            <Col xs={getTamanho(565) ? 12 : 4}>
                              <Form.Group>
                                <Form.Label>Data Inicial:</Form.Label>
                                <DatePicker
                                  dateFormat="dd/MM/yyyy"
                                  disabled={!editable}
                                  selected={getValue('start_at')}
                                  onChange={
                                    (e) => {
                                      setValue('start_at', e);
                                      setStartDate(e);
                                    }
                                  }
                                  className="form-control"
                                />
                              </Form.Group>
                            </Col>
                            <Col xs={getTamanho(565) ? 12 : 4}>
                              <Form.Group>
                                <Form.Label>Data Final:</Form.Label>
                                <DatePicker
                                  dateFormat="dd/MM/yyyy"
                                  disabled={!editable}
                                  selected={getValue('end_at')}
                                  onChange={(e) => setValue('end_at', e)}
                                  minDate={startDate}
                                  className="form-control"
                                />
                              </Form.Group>
                            </Col>
                            {action.step
                              ? createField(action.step.fields, action, steps)
                              : ''}

                            {getValue('subcategory_id') == 6 ? (
                              <Col xs={12}>
                                <Form.Group>
                                  <Form.Label>
                                    Pagamento Requerido:
                                  </Form.Label>
                                  {getValue('payment_require') == 2 ? (
                                    <BAlert variant='warning'>
                                      <small>A quitação se dará somente se o valor total da NF de compra for compatível com valor líquido da NF emitida. 
                                      Caso o valor da compra seja superior a verba disponível/NF emitida, será gerado cobrança da diferença.</small>
                                    </BAlert>
                                  ) : null}
                                  <Form.Control
                                    disabled={!editable}
                                    as="select"
                                    value={getValue('payment_require')}
                                    onChange={({ target })=> setValue('payment_require', target.value)}
                                  >
                                    <option value="" selected disabled>Selecione</option>
                                    <option value={1}>Reembolso (depósito)</option>
                                    <option value={2}>Encontro de Contas/Abatimento parcial</option>
                                  </Form.Control>
                                </Form.Group>
                              </Col>
                            ) : null}
                            <Col xs={12}>
                              <Form.Group>
                                <Form.Label>Descrição:</Form.Label>
                                <textarea
                                  disabled={!editable}
                                  value={getValue('description')}
                                  onChange={(e) =>
                                    setValue('description', e.target.value)
                                  }
                                  className="form-control"
                                ></textarea>
                              </Form.Group>
                            </Col>
                            <Col xs={12}>
                              <Form.Group>
                                <OverlayTrigger
                                  placement="bottom"
                                  delay={{ show: 250, hide: 400 }}
                                  overlay={renderTooltip}
                                >
                                  <Form.Label>
                                    Arquivos{' '}
                                    <HelpOutline className="ml-1 icon-menu" />
                                  </Form.Label>
                                </OverlayTrigger>
                                <FileUploadMultiple
                                  disabled={
                                    !editable &&
                                    actionAux &&
                                    actionAux.action_status_id !==
                                    ActionStatus().EmExecucao &&
                                    actionAux.action_status_id !==
                                    ActionStatus().NFRejeitada &&
                                    actionAux.action_status_id !==
                                    ActionStatus().AguardandoPagamento
                                  }
                                  files={[...file]}
                                  setFiles={(files) => setFile(files)}
                                  filesComments={[...filecomments]}
                                  setFilesComments={(filesComments) =>
                                    setFilecomments(filesComments)
                                  }
                                  existingFiles={[]}
                                  filesSaved={action.files}
                                />
                              </Form.Group>
                            </Col>
                            <Col xs={12}>
                              <Form.Group>
                                <Form.Label>Comentário:</Form.Label>
                                <textarea
                                  value={getValue('action_history_description')}
                                  onChange={(e) =>
                                    setValue(
                                      'action_history_description',
                                      e.target.value
                                    )
                                  }
                                  className="form-control"
                                ></textarea>
                              </Form.Group>
                            </Col>
                            {steps && steps.length > 0 ? (
                              <>
                                <Col xs={12}>
                                  {steps.map((steps, k) => {
                                    return (
                                      <Button
                                        key={k}
                                        type="submit"
                                        className="m-1 btnsubmit"
                                        onClick={() => {
                                          setValue('action_status_id', steps.id);
                                          setActionToShow(steps.name)
                                        }}
                                      >
                                        {t('flow:' + steps.name)}
                                      </Button>
                                    );
                                  })}
                                </Col>
                              </>
                            ) : (
                                ''
                              )}
                          </Row>
                        </Form>
                      </Col>
                    </Row>
                  </Card.Body>
                </Col>
                {getTamanho(991) ? '' : (
                  <Col md='12' lg='5' xs="12" xl="4" className="p-2 ">
                    <Card.Body className="card-dashboard shadow bg-white rounded text-left box-funds row w-100 m-0">
                      <div id="fund-table" className="col-md-12">
                        <Row className="mb-4">
                          <WidgetsOutlined className="icon-title" />
                          <h5 className="title-dashboard">Fundos</h5>
                        </Row>
                        {actionId ? (
                          demonstrative && demonstrative.length > 0 && action.funds ? (
                            <div className="card mb-4">
                              <div className="card-body">
                                <h6 className="mt-0">
                                  {((bu)=>{
                                    switch (parseInt(bu)) {
                                      case 1:
                                        return "Comms"
                                        break;
                                      case 2:
                                        return "Pos"
                                        break;
                                      case 3:
                                        return "Disponível"
                                        break;
                                      default:
                                        return "Disponível"
                                        break;
                                    }
                                  })(action.funds[0].business_unity_id)}
                                </h6>
                                {(() => { 
                                  try {
                                    return demonstrative.filter(a => {
                                      return a.filter(b => b.bu == action.funds[0].business_unity_id)[0]
                                    })[0].map((item, j) => (
                                      <div
                                        key={j}
                                        className="fund-value fund-id-{{ $item['id'] }}"
                                      >
                                        <small className="text-gray">
                                          <span id="fund-name">{item['name']}</span>
                                        </small>
                                        <h3
                                          className="card-title mt-0"
                                          id="fund-free-fund"
                                        >
                                          {item.freeFund.toLocaleString('pt-BR', {
                                            style: 'currency',
                                            currency: 'BRL',
                                          })}
                                        </h3>
                                      </div>
                                    ))
                                  } catch (error) {
                                    return (<></>)
                                  }                                  
                                })()}
                              </div>
                            </div>
                          ) : (
                              ''
                            )
                        ) : action.bu && demonstrative ? (
                          <div className="card mb-4">
                            <div className="card-body">
                              <h6 className="mt-0">
                              {((bu)=>{
                                    switch (parseInt(bu)) {
                                      case 1:
                                        return "Comms"
                                        break;
                                      case 2:
                                        return "Pos"
                                        break;
                                      case 3:
                                        return "Disponível"
                                        break;
                                      default:
                                        break;
                                    }
                                  })(action.bu)}
                              </h6>
                              {/* {demonstrative[action.bu - 1] ? demonstrative[action.bu - 1].map((item, j) => ( */}
                              {demonstrative.filter(a => {
                                return a.filter(b=>b.bu == action.bu)[0];
                              })[0] ? demonstrative.filter(a =>{
                                return a.filter(b=>b.bu == action.bu)[0];
                              })[0].map((item, j) => (
                                <div
                                  key={j}
                                  className="fund-value fund-id-{{ $item['id'] }}"
                                >
                                  <small className="text-gray">
                                    <span id="fund-name">{item['name']}</span>
                                  </small>
                                  <h3 className="card-title mt-0" id="fund-free-fund">
                                    {item['freeFund'].toLocaleString('pt-BR', {
                                      style: 'currency',
                                      currency: 'BRL',
                                    })}
                                  </h3>
                                </div>
                              )) :
                                <div
                                  className="fund-value fund-id-1"
                                >
                                  <small className="text-gray">
                                    <span id="fund-name">Sem fundos</span>
                                  </small>
                                </div>
                              }
                            </div>
                          </div>
                        ) : demonstrative ? (
                          demonstrative.map((bu, i) => (
                            <div key={i} className="card mb-4">
                              <div className="card-body">
                                <h6 className="mt-0">{((bu)=>{
                                    switch (parseInt(bu)) {
                                      case 1:
                                        return "Comms"
                                        break;
                                      case 2:
                                        return "Pos"
                                        break;
                                      case 3:
                                        return "Disponível"
                                        break;
                                      default:
                                        break;
                                    }
                                  })(i)}</h6>
                                {bu.map((item, j) => (
                                  <div
                                    key={j}
                                    className="fund-value fund-id-{{ $item['id'] }}"
                                  >
                                    <small className="text-gray">
                                      <span id="fund-name">{item['name']}</span>
                                    </small>
                                    <h3
                                      className="card-title mt-0"
                                      id="fund-free-fund"
                                    >
                                      {item['freeFund'].toLocaleString('pt-BR', {
                                        style: 'currency',
                                        currency: 'BRL',
                                      })}
                                    </h3>
                                  </div>
                                ))}
                              </div>
                            </div>
                          ))
                        ) : (
                                ''
                              )}
                      </div>
                    </Card.Body>
                  </Col>
                )}
              </Row>
              <Row>{actionAux ? <Historic action={action} /> : ''}</Row>
              {getTamanho(991) ? (<>
                <Row className="mt-3"></Row>
                <div id="funds-mobile" className={fundsMobileCollapsed ? 'funds-mobile-collapsed' : ''}
                  onClick={() => setFundsMobileCollapsed(!fundsMobileCollapsed)}>
                  <div id="fund-table" className="col-md-12" style={{ position: 'relative', height: '100%' }}>
                    <Row style={{ height: '44px' }}>
                      <WidgetsOutlined className="icon-title" />
                      <h5 className="title-dashboard">Fundos</h5>
                      <FontAwesomeIcon icon={fundsMobileCollapsed ? faChevronUp : faChevronDown} style={{
                        top: '12px',
                        position: 'absolute',
                        right: '20px'
                      }} />
                    </Row>
                    <div className="funds-mobile-area">
                      {actionId ? (
                        demonstrative && demonstrative.length > 0 && action.funds ? (
                          <div className="card mb-4">
                            <div className="card-body">
                              <h6 className="mt-0">
                              {((bu)=>{
                                switch (parseInt(bu)) {
                                  case 1:
                                    return "Comms"
                                    break;
                                  case 2:
                                    return "Pos"
                                    break;
                                  case 3:
                                    return "Disponível"
                                    break;
                                  default:
                                    break;
                                }
                              })(action.funds[0].business_unity_id)}
                              </h6>
                              {demonstrative[
                                action.funds[0].business_unity_id - 1
                              ].map((item, j) => (
                                <div
                                  key={j}
                                  className="fund-value fund-id-{{ $item['id'] }}"
                                >
                                  <small className="text-gray">
                                    <span id="fund-name">{item['name']}</span>
                                  </small>
                                  <h3
                                    className="card-title mt-0"
                                    id="fund-free-fund"
                                  >
                                    {item['freeFund'].toLocaleString('pt-BR', {
                                      style: 'currency',
                                      currency: 'BRL',
                                    })}
                                  </h3>
                                </div>
                              ))}
                            </div>
                          </div>
                        ) : (
                            ''
                          )
                      ) : action.bu && demonstrative ? (
                        <div className="card mb-4">
                          <div className="card-body">
                            <h6 className="mt-0">
                            {((bu)=>{
                                    switch (bu) {
                                      case 1:
                                        return "Comms"
                                        break;
                                      case 2:
                                        return "Pos"
                                        break;
                                      case 3:
                                        return "Disponível"
                                        break;
                                      default:
                                        break;
                                    }
                                  })(action.bu)}
                            </h6>
                            {demonstrative[action.bu - 1] ? demonstrative[action.bu - 1].map((item, j) => (
                              <div
                                key={j}
                                className="fund-value fund-id-{{ $item['id'] }}"
                              >
                                <small className="text-gray">
                                  <span id="fund-name">{item['name']}</span>
                                </small>
                                <h3 className="card-title mt-0" id="fund-free-fund">
                                  {item['freeFund'].toLocaleString('pt-BR', {
                                    style: 'currency',
                                    currency: 'BRL',
                                  })}
                                </h3>
                              </div>
                            )) :
                              <div
                                className="fund-value fund-id-1"
                              >
                                <small className="text-gray">
                                  <span id="fund-name">Sem fundos</span>
                                </small>
                              </div>
                            }
                          </div>
                        </div>
                      ) : demonstrative ? (
                        demonstrative.map((bu, i) => (
                          <div key={i} className="card mb-4">
                            <div className="card-body">
                              <h6 className="mt-0">
                              {((bu)=>{
                                    switch (parseInt(bu)) {
                                      case 1:
                                        return "Comms"
                                        break;
                                      case 2:
                                        return "Pos"
                                        break;
                                      case 3:
                                        return "Disponível"
                                        break;
                                      default:
                                        return "Disponível"
                                        break;
                                    }
                                  })(i)}
                              </h6>
                              {bu.map((item, j) => (
                                <div
                                  key={j}
                                  className="fund-value fund-id-{{ $item['id'] }}"
                                >
                                  <small className="text-gray">
                                    <span id="fund-name">{item['name']}</span>
                                  </small>
                                  <h3
                                    className="card-title mt-0"
                                    id="fund-free-fund"
                                  >
                                    {item['freeFund'].toLocaleString('pt-BR', {
                                      style: 'currency',
                                      currency: 'BRL',
                                    })}
                                  </h3>
                                </div>
                              ))}
                            </div>
                          </div>
                        ))
                      ) : (
                              ''
                            )}
                    </div>
                  </div>
                </div>
              </>) : ''}
            </Container>
          )
      ) : (
          showMessageErro()
        )}
    </>
  );
};

export default ShowV1;
